module.exports = __webpack_public_path__ + "static/porkribs-d32d4a1c5bc2a5c0074f174869eddf72.jpg";